import { IconButton } from "@mui/material";
import {
  XIcon,
  ArrowsLeftRightIcon,
  ArrowRightIcon,
} from "@phosphor-icons/react";

import { BackButton } from "@/components/BackButton/BackButton";
import { TripType } from "@/features/flights/types/types";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { getCityName } from "@/utils/locations";

type Props = {
  searchData: FlightSearchFormValues;
  onCancel: () => void;
  onBack: () => void;
};

const Header = ({ searchData, onCancel, onBack }: Props) => {
  return (
    <div className="flex items-center justify-between p-2">
      <BackButton onClick={onBack} />
      <div className="flex items-center justify-center gap-2">
        <h3 className="font-medium text-text-title">
          {getCityName(searchData.from)}
        </h3>
        {searchData.tripType === TripType.ROUND_TRIP ? (
          <ArrowsLeftRightIcon size={16} color="#003E2B" />
        ) : (
          <ArrowRightIcon size={16} color="#003E2B" />
        )}
        <h3 className="font-medium text-text-title">
          {getCityName(searchData.to)}
        </h3>
      </div>
      <IconButton onClick={onCancel}>
        <XIcon size={24} color="text-text-title" />
      </IconButton>
    </div>
  );
};

export default Header;
